export const peripheryAddresses = {
  adaptiveCurveIRMFactory: "0xcC8169EDFfe94726823fA71e0E7C64F130208c7e",
  capRiskStewardFactory: "0x677C1a9C7E12e9426c02ACf23C71eC5BC8D7309A",
  edgeFactory: "0xAd9Ed33315c8bF601c0A8Cf34cF6E3ca93a2144d",
  edgeFactoryPerspective: "0xe0DdB3b94104757865Fe5165a59AE55767573Ea9",
  escrowedCollateralPerspective: "0xA269918388E3824b5B9316C20c8D5f9D558b73CA",
  eulerEarnFactoryPerspective: "0xE5f18b8E25E60F74d627FdDc6805Ec3cBE853573",
  eulerEarnGovernedPerspective: "0xAA8b9729a047568CB0614165509229A86e345Be1",
  eulerEarnPublicAllocator: "0x667aD135188d95a32A4E743Aebe5a5b503cb9038",
  eulerUngoverned0xPerspective: "0x586471dAe0AEe957e053399347b23eFD0a69eD74",
  eulerUngovernedNzxPerspective: "0x23Fd93a4AC2A0d87785Acd925BcfebA550006327",
  evkFactoryPerspective: "0xAEA0DE17C8B1BE60B2949B7F17482EBe681F93DF",
  externalVaultRegistry: "0xc92a47A62322914472eaCe515Cd1c5DAC31FCa37",
  feeCollector: "0x0000000000000000000000000000000000000000",
  feeFlowController: "0xBCc714F3ce3F56aB4A85a10d593cF9C93ED6ED9e",
  feeFlowControllerUtil: "0x730a68b4dfD36b804a6466678059B838632f1CF1",
  fixedCyclicalBinaryIRMFactory: "0xfdb6D727785485f87caBEc64204cd7EBc930ef11",
  governedPerspective: "0xBD62C2Db0E21E4B9Ee81701F130417B8400ec854",
  governorAccessControlEmergencyFactory:
    "0xDb4bD54647169b0d2b0414EfE943A92b6B8E9886",
  irmRegistry: "0xe5F7889cA0cF16926eb73a523ea364B8539aaf87",
  kinkIRMFactory: "0xACd19b80db7AF45BDdd5fD58dbc5dFe194137dB6",
  kinkyIRMFactory: "0x6C72E825D37323F711bAc4aDaaE275ba5e3AEaF1",
  oracleAdapterRegistry: "0xe7581A54eBEcC02B42a9c0b4044abC9bb75A502D",
  oracleRouterFactory: "0x7e539159a06CFe0A9f855d22dD82aD95eDf8C2F1",
  swapVerifier: "0xB695C0aC484F46dD8f279452209b8C53674974bD",
  swapper: "0x419730b755c6e76B42D2CaD9a2674a8DC748dA38",
  termsOfUseSigner: "0x35E815aC40456bf14614F11A281FD09fcAb19beE",
} as const
